// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_Bpd","importantInfo":"styles_importantInfo__21np6"};